import { render, staticRenderFns } from "./announcementDialog.vue?vue&type=template&id=da60a07a&scoped=true&"
import script from "./announcementDialog.vue?vue&type=script&lang=js&"
export * from "./announcementDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da60a07a",
  null
  
)

export default component.exports